import { useEffect, useState } from 'react';
import { isEmpty } from 'underscore';
import useAuthStore from '../../../../store/authStore';
import useCartStore from '../../../../store/cartStore';

interface CheckoutEligibilityProps {
  checkPolicy: boolean;
  emptyPrice: boolean;
}

export default function useCheckoutEligibility({
  checkPolicy,
  emptyPrice,
}: CheckoutEligibilityProps) {
  const user = useAuthStore((state) => state.user);
  const userProfile = useAuthStore((state) => state.userProfile);
  const shoppingItems = useCartStore((state) => state.shoppingItems);

  const [checkoutDisabled, setCheckoutDisabled] = useState<boolean>(true);

  useEffect(() => {
    const enableCheckout =
      checkPolicy && userProfile !== undefined && !emptyPrice;

    if (isEmpty(user) || isEmpty(shoppingItems)) {
      setCheckoutDisabled(true);
    } else {
      setCheckoutDisabled(!enableCheckout);
    }
  }, [userProfile, checkPolicy, user, shoppingItems, emptyPrice]);

  return { checkoutDisabled };
}
